module.exports = __webpack_public_path__ + "img/3a4f609.png";